import React, { useState, useEffect, useContext } from "react";
import "./CCBalanceTransfer.css";
import { pageData } from "./balanceTransferData.js";
import CalculatorResults from "./BalanceTransferPages/CalculatorResult/CalculatorResult.jsx";
import SideLinks from "./SideLinks/SideLinks.jsx";
import SavingCalculator from "./SavingCalculator/SavingCalculator.jsx";
import TableData from "./BalanceTransferPages/TableData/TableData.jsx";
import CostOfDebt from "./BalanceTransferPages/TableData/CostOfDebt.jsx";
import PaymentCalculator from "./MonthlyPaymentCalculator/PaymentCalculator.jsx";
import TransfersWork from "./BalanceTransferPages/TransfersWork/TransfersWork.jsx";
import MoreLikeThis from "./MoreLikeThis/MoreLikeThis.jsx";
import FAQ from "./FAQ/FAQ.jsx";
import {
  Typography,
  Tooltip,
  tooltipClasses,
  styled,
  ClickAwayListener,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import Collaborators from "./Collaborators/Collaborators.jsx";
import { getLoanData } from "./balanceTransferData.js";
import TipTwo from "./BalanceTransferPages/CalculatorResult/TipTwo.jsx";
import Perspectives from "./Perspectives/Perspectives.jsx";
import MetadataContext from "../../../Pages/MetadataContext.js";

const CCBalanceTransfer = () => {
  const isSmallScreen = useMediaQuery("(max-width:576px) ");
  // State for aside sidelinks

  const [showAside, setShowAside] = useState(false);
  const [openDiscloser, setOpenDiscloser] = useState(false);

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  const handeDiscloserTooltipClose = () => {
    setOpenDiscloser(false);
  };

  const handeDiscloserTooltipOpen = () => {
    setOpenDiscloser(true);
  };

  useEffect(() => {
    // Delay showing the aside content until the page is loaded
    const timer = setTimeout(() => {
      setShowAside(true);
    }, 1000); // Adjust the time as needed

    // Clean up the timer when the component unmounts
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { setMetadata } = useContext(MetadataContext);

  useEffect(() => {
    setMetadata({
      pageTitle: "Credit Card Balance Transfer Calculator | Minemi.ai",
      pageDescription:
        "Use Minemi.ai's credit card balance transfer calculator to estimate savings, compare interest rates, and find the best offers for your credit card transfer",
      pageKeywords:
        "credit card balance transfer calculator,balance transfer calculator",
      canonicalUrl:
        "https://minemi.ai/calculators/financial-insights-and-tools/credit-card-balance-transfer-blog",
    });
  }, [setMetadata]);

  const advertiserData = (
    <div>
      <Typography>
        Minemi partners with trusted lenders, and we may receive compensation
        when you click on links or take action on their site. However, this does
        not affect our evaluations or ratings. Our opinions are our own.
      </Typography>
          
    </div>
  );
  return (
    <>
      <div id="page_container">
        <div className="">
          <div className="details_data d-flex align-items-start flex-row gap-5">
            <div className="balance_transfer">
              <section id="hero-page-links">
                <p className="pages_links bg-transparent links ">
                  <Link
                    to="/"
                    underline="hover"
                    className="bg-transparent archivo"
                    style={{
                      fontSize: isSmallScreen ? 13 : 16,
                      color: "#59266d",
                      cursor: "pointer",
                      fontFamily: "'Archivo', sans-serif",
                    }}
                  >
                    Home
                  </Link>
                  &nbsp;
                  <span
                    className="d-none d-md-inline bg-transparent ps-1 px-1 "
                    style={{
                      color: "#59266D",
                      fontFamily: "'Archivo', sans-serif",
                      fontWeight: 700,
                    }}
                  >
                    &gt;
                  </span>
                  &nbsp;
                  <Link
                    to="/calculators"
                    underline="hover"
                    className="d-none d-md-inline bg-transparent archivo"
                    style={{
                      fontSize: isSmallScreen ? 13 : 16,
                      color: "#59266d",
                      cursor: "pointer",
                      fontFamily: "'Archivo', sans-serif",
                    }}
                  >
                    Calculators
                  </Link>
                  &nbsp;
                  <span
                    className="d-none d-md-inline bg-transparent ps-1 px-1 "
                    style={{
                      color: "#59266D",
                      fontFamily: "'Archivo', sans-serif",
                      fontWeight: 700,
                    }}
                  >
                    &gt;
                  </span>
                  &nbsp;
                  <Link
                    to="/calculators/financial-insights-and-tools"
                    underline="hover"
                    className="d-none d-md-inline bg-transparent archivo"
                    style={{
                      fontSize: isSmallScreen ? 13 : 16,
                      color: "#59266d",
                      cursor: "pointer",
                      fontFamily: "'Archivo', sans-serif",
                    }}
                  >
                    Financial Insights and Tools
                  </Link>
                  &nbsp;
                  <span
                    className="d-none d-md-inline bg-transparent ps-1 px-1 "
                    style={{
                      color: "#59266D",
                      fontFamily: "'Archivo', sans-serif",
                      fontWeight: 700,
                    }}
                  >
                    &gt;
                  </span>
                  &nbsp;
                  <Link
                    underline="hover"
                    className="d-none d-md-inline fw-bold bg-transparent archivo"
                    style={{
                      fontSize: isSmallScreen ? 13 : 16,
                      color: "#59266d",
                      cursor: "pointer",
                      fontFamily: "'Archivo', sans-serif",
                    }}
                  >
                    Credit Card Balance Transfer Calculator{" "}
                  </Link>{" "}
                </p>
              </section>

              {getLoanData &&
                getLoanData.map((item, index) => (
                  <div key={index} className="contents bg-transparent my-3">
                    <div className=" mt-4 mt-lg-5">
                      <div id="advertiser__discloser">
                        <ClickAwayListener
                          onClickAway={handeDiscloserTooltipClose}
                        >
                          <div className="w-auto">
                            <LightTooltip
                              arrow
                              open={openDiscloser}
                              title={<div>{advertiserData}</div>}
                            >
                              <div>
                                <Link
                                  underline="hover"
                                  style={{
                                    fontSize: 13,
                                    lineHeight: "20px",
                                    fontFamily: "'Archivo', sans-serif",
                                  }}
                                  onClick={handeDiscloserTooltipOpen} // Only this triggers tooltip to open
                                >
                                  Advertiser disclosure
                                </Link>
                              </div>
                            </LightTooltip>
                          </div>
                        </ClickAwayListener>
                      </div>
                      <div className="content_heading d-flex flex-column align-items-start mt-2">
                        <Typography
                          className="bg-transparent archivo fw-bold"
                          sx={{
                            fontSize: {
                              xs: "32px",
                              sm: "35.4312px",
                              md: "40.2752px",
                              lg: "53.1927px",
                            },
                            lineHeight: {
                              xs: "38px",
                              sm: "42.0745px",
                              md: "47.8268px",
                              lg: "63.1663px",
                            },
                            letterSpacing: "0.04px",
                            textAlign: "start",
                            fontFamily: "'Archivo', sans-serif",
                          }}
                        >
                          {item.heading}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 16,
                            lineHeight: "24px",
                            letterSpacing: "0.08px",
                            fontFamily: "'Archivo',sans-serif",
                          }}
                          className="sub-heading bg-transparent my-2 archivo"
                        >
                          {item.subHeading}
                        </Typography>
                      </div>

                      <div>
                        <img
                          src="https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/credit-card-1737027764144.webp"
                          alt="credit-card-balance-transfer-image"
                          loading="lazy"
                          className="bt-hero-img  "
                        />
                      </div>
                      <div className="notice rounded">
                        <Typography
                          sx={{
                            fontSize: "11.008px",
                            lineHeight: "16.512px",
                            letterSpacing: "0.64px",
                            textAlign: "start",
                            // color: "#ffffff",
                            color: "#000",
                            fontFamily: "'Archivo', sans-serif",
                          }}
                          className="notic_text bg-transparent archivo  p-2 my-3"
                        >
                          {item.notice}
                        </Typography>
                      </div>
                    </div>
                    <div id="updation_content" className="mt-4">
                      <div className="d-flex">
                        <p className="updation_heading archivo">
                          {item.updationText}{" "}
                          <span className="archivo">
                            &nbsp;{item.updateTime}
                          </span>
                        </p>
                      </div>
                      <div className="">
                        <Collaborators />
                      </div>
                    </div>
                  </div>
                ))}
              <div className="hero-paragraphs ">
                <Typography
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    fontSize: "16px",
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    textAlign: "start",
                  }}
                >
                  {pageData[0].intro}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    fontSize: "16px",
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    textAlign: "start",
                    padding: "1rem 0",
                  }}
                >
                  {pageData[0].subpara}
                </Typography>
              </div>

              <div className=" pt-4">
                <SavingCalculator />
              </div>

              <CalculatorResults />

              <TableData />
              <section>
                <Perspectives />
              </section>
              <CostOfDebt />

              <PaymentCalculator />

              <TransfersWork />
              <section>
                <TipTwo />
              </section>

              <section>
                <FAQ />
              </section>
            </div>

            <aside id="side_page_data" className="  ">
              <div className=" ">
                {/* Show the aside content if showAside is true */}
                {/* {showAside && <SideLinks />}{" "} */}
                <SideLinks />
              </div>
            </aside>
          </div>

          <section>
            <MoreLikeThis />
          </section>
        </div>
      </div>
    </>
  );
};

export default CCBalanceTransfer;
